import {
  FormField,
  type FormFieldProps,
  Option,
  Select,
  type SelectProps,
} from '@moia-dev/pace-web'
import { useId } from 'react'

export type SelectfieldProps<Value> = Omit<FormFieldProps, 'children'> &
  SelectProps<Value>

export const Selectfield = <Value,>({
  label,
  caption,
  id: maybeId,
  required,
  validation,
  value,
  onChange,
  ...props
}: SelectfieldProps<Value>) => {
  const generatedId = useId()
  const id = maybeId ? maybeId : generatedId
  return (
    <FormField
      caption={caption}
      htmlFor={id}
      label={label}
      required={required}
      validation={validation}
    >
      <Select id={id} {...props} value={value} onChange={onChange} />
    </FormField>
  )
}

export const SelectfieldOption: typeof Option = Option
